import { AsyncPipe, NgIf } from '@angular/common';
import { HttpHeaders } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs/operators';
import { DevBypassHelperComponent } from './components/bypass-helper/dev-bypass-helper.component';
import { saveToStorage } from './helpers/storageUtils';
import { DevtoolsDetectorService } from './services/devtools.service';
import { LoaderService } from './services/loader.service';
import { MobilityLoaderComponent } from './shared/components/mobility-loader/mobility-loader.component';
import { TokenService } from './shared/services/token.service';
import { UtmHandlerService } from './shared/services/utm-handler.service';

@Component({
  selector: 'motos-app',
  standalone: true,
  imports: [RouterOutlet, DevBypassHelperComponent, MobilityLoaderComponent, AsyncPipe, NgIf],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  tokenService = inject(TokenService);
  utmHandlerService = inject(UtmHandlerService);
  devtoolsDetectorService = inject(DevtoolsDetectorService);
  public loaderService = inject(LoaderService);
  title = 'Motos';
  sessionId = '';
  index = 0;

  constructor(
    private router: Router,
    private metaService: Meta,
    private titleService: Title,
  ) {
    const dataLayer = (window as any).dataLayer as any[];
    const gtmStart = dataLayer?.[0]?.['gtm.start'];
    this.sessionId = gtmStart ? String(gtmStart) : Date.now().toString();
    saveToStorage('session_id', this.sessionId);

    router.events
      .pipe(filter((routerEvent: any) => routerEvent instanceof NavigationEnd))
      .subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit(): void {
    // Inicializar el detector de herramientas de desarrollo
    this.devtoolsDetectorService.initialize();

    this.tokenService.initializeToken().subscribe(
      (response) => {
        // Token inicializado exitosamente
      },
      (error) => {
        console.error('Error initializing authentication');
      },
    );
    const httpOptions = { headers: new HttpHeaders() };
    httpOptions.headers.append('Content-Type', 'application/x-gzip');

    this.router.events.subscribe((item) => {
      if (item instanceof NavigationEnd) {
        if (this.index == 0) {
          // this._dataLayerService.logPageLoad("ecommerce_step_0", "Viajes", "Inicio Viajes", this.sessionId);
          this.index = this.index + 1;
        }
      }
    });

    this.titleService.setTitle('Cotiza tu Seguro de Moto Digital - SURA');

    this.metaService.updateTag({
      name: 'keywords',
      content: 'seguro de moto precio',
    });

    this.metaService.updateTag({
      name: 'description',
      content:
        'Conoce rápida y fácilmente el precio de tu seguro de moto digital. Cotizándolo en pocos segundos. Haz clic aquí',
    });
  }
}
